import { isNil } from "ramda";
import { FC } from "react";
import { Datagrid, List, ListProps, TextField } from "react-admin";

import CustomPagination from "../../components/CustomPagination";
import EmptyDataText from "../../components/EmptyDataText";
import ListImage from "../../components/ListImage";
import TimestampField from "../../components/TimestampField";
import UseLocalizedRAFields from "../../hooks/useLocalizedRAFields";
import useSharedStyles from "../../hooks/useSharedStyles";
import EnablePropertyCompanyButton from "./components/DeleteUserGuidwButton";

const CustomBulkActions = (props: any) => <EnablePropertyCompanyButton label="Delete" {...props} />;

const UserGuideList: FC<ListProps> = (props) => {
  const { styles } = useSharedStyles();

  const localizedFields = UseLocalizedRAFields([
    {
      key: "title",
      label: "Title",
      cellClassName: styles.truncate3,
      sortable: false,
    },
    {
      key: "description",
      label: "Description",
      cellClassName: styles.truncate3,
      sortable: false,
    },
  ]);

  return (
    <List {...props} pagination={<CustomPagination />} exporter={false} bulkActionButtons={<CustomBulkActions />}>
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No userguide yet!" />}>
        <TextField source="sortIndex" label="Index" sortable={false} />
        {!isNil(localizedFields) && [localizedFields[0], localizedFields[1]]}
        <ListImage source="backgroundImage.src" label="Background Image" sortable={false} />
        <ListImage source="icon.src" label="Icon" sortable={false} />
        {!isNil(localizedFields) && [localizedFields[2], localizedFields[3]]}
        <TimestampField source="createdAt" label="Created At" sortable={false} />
      </Datagrid>
    </List>
  );
};

export default UserGuideList;
